export enum ChartType {
    Standard = 0,
    Negative,
    PositiveWithNegativeBack,
}
